import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '@Root/slices'
import { fetchChart, fetchRealPriceTable, fetchSummary, fetchTable, MyhousePriceParam, updateTradeType, updatePeriod } from '@Root/slices/myhouse/price'
import { TRADE } from '@Root/contants'

export default function usePrice() {
  const dispatch = useDispatch()
  const price = useSelector((state: RootState) => state.myhousePrice)

  const setPeriod = useCallback(
    (period: number) => {
      dispatch(updatePeriod(period))
    },
    [dispatch],
  )

  const setTradeType = useCallback(
    (tradeType: TRADE) => {
      dispatch(updateTradeType(tradeType))
    },
    [dispatch],
  )

  const loadChart = useCallback(
    (param: MyhousePriceParam) => {
      dispatch(fetchChart(param))
    },
    [dispatch],
  )

  const loadTable = useCallback(
    (param: MyhousePriceParam) => {
      dispatch(fetchTable(param))
    },
    [dispatch],
  )

  const loadRealPriceTable = useCallback(
    (param: MyhousePriceParam) => {
      dispatch(fetchRealPriceTable(param))
    },
    [dispatch],
  )

  const loadSummary = useCallback(
    (param: MyhousePriceParam) => {
      dispatch(fetchSummary(param))
    },
    [dispatch],
  )

  return {
    price,
    loadChart,
    loadTable,
    loadRealPriceTable,
    loadSummary,
    setPeriod,
    setTradeType,
  }
}
